module.exports = __webpack_public_path__ + "static/media/additional_product_features.f7a9017c.png";